import { fromIsoString, toIsoString } from '../chat/iso-date';
import type { WorkflowTriggerBindingData } from './types';
import type { SerializedWorkflowTriggerBinding } from './types';

/**
 * Maps a polymorphic trigger (`trigger_type` + `trigger_id`) to a workflow (`workflow_trigger_workflows`).
 */
export class WorkflowTriggerBinding {
  private readonly _data: WorkflowTriggerBindingData;

  private constructor(data: WorkflowTriggerBindingData) {
    this._data = data;
  }

  get id(): string {
    return this._data.id;
  }

  get ownerId(): string {
    return this._data.ownerId;
  }

  get ownerOrgId(): string {
    return this._data.ownerOrgId;
  }

  get triggerType(): string {
    return this._data.triggerType;
  }

  get triggerId(): string {
    return this._data.triggerId;
  }

  get workflowId(): string {
    return this._data.workflowId;
  }

  get enabled(): boolean {
    return this._data.enabled;
  }

  get priority(): number {
    return this._data.priority;
  }

  get defaultInput(): unknown {
    return this._data.defaultInput;
  }

  get createdAt(): Date {
    return this._data.createdAt;
  }

  get updatedAt(): Date {
    return this._data.updatedAt;
  }

  get triggerBindingData(): WorkflowTriggerBindingData {
    return { ...this._data };
  }

  serialize(): SerializedWorkflowTriggerBinding {
    return {
      id: this._data.id,
      ownerId: this._data.ownerId,
      ownerOrgId: this._data.ownerOrgId,
      triggerType: this._data.triggerType,
      triggerId: this._data.triggerId,
      workflowId: this._data.workflowId,
      enabled: this._data.enabled,
      priority: this._data.priority,
      defaultInput: this._data.defaultInput,
      createdAt: toIsoString(this._data.createdAt),
      updatedAt: toIsoString(this._data.updatedAt),
    };
  }

  static fromSerialized(
    serialized: SerializedWorkflowTriggerBinding
  ): WorkflowTriggerBinding {
    const data: WorkflowTriggerBindingData = {
      id: serialized.id,
      ownerId: serialized.ownerId,
      ownerOrgId: serialized.ownerOrgId,
      triggerType: serialized.triggerType,
      triggerId: serialized.triggerId,
      workflowId: serialized.workflowId,
      enabled: serialized.enabled,
      priority: serialized.priority,
      defaultInput: serialized.defaultInput,
      createdAt: fromIsoString(serialized.createdAt),
      updatedAt: fromIsoString(serialized.updatedAt),
    };
    return new WorkflowTriggerBinding(data);
  }
}
